import { Card, IconButton } from "@mui/material";
import styled from "styled-components";

const CustomCard = styled(Card)`
  &.MuiPaper-root {
    padding: 8px 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const ActionButton = styled(IconButton)`
  &.MuiIconButton-root {
    border-radius: 0;
    &.is-active {
      background-color: #f0f0f0;
    }
  }
`;

export { CustomCard, ActionButton };
